<!-- Step 6 (plan): load-after-universal-auth-enabled on underlying web component when supported -->
<app-pep-syndicated-header
  *ngIf="syndicatedHeaderConfig"
  [basePath]="syndicatedHeaderConfig.path"
  [version]="syndicatedHeaderConfig.version"
  [siteId]="syndicatedHeaderConfig.siteId"
  [environment]="syndicatedHeaderConfig.environment"
  [hideNavigation]="1"
  load-after-universal-auth-enabled
  [isUniversalAuthEnabled]="isUniversalAuthEnabled"
  class="header">
</app-pep-syndicated-header>
<router-outlet></router-outlet>
